






















































































































































































import { Vue, Component } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import { Usuario } from "@/typings/store/plugins/easyFirestore/usuarios";
import { DataFormularioUsuario } from "@/typings/components/usuarios/formulario";
import { idtify } from "@/helpers/string";
import FormularioPerfil from "@/components/perfil/Formulario.vue";
import DialogoExito from "@/components/DialogoExito.vue";

const DetalleItem = Vue.extend({
  functional: true,
  props: ["label", "value", "icon"],
  render(h, { props }) {
    const icon = props.icon
      ? h("v-icon", { class: "mr-2 mt-n1", props: { small: true, color: "primary" } }, props.icon)
      : null;
    return h(
      "v-col",
      { props: { cols: 12, sm: 6 }, class: "detalle-item-col mb-3" },
      [
        h("div", { class: "text-caption grey--text text--darken-1 poppins mb-1 d-flex align-center" }, [
          icon,
          props.label,
        ]),
        h("div", { class: "font-weight-medium text-body-2 primary--text poppins" }, props.value || "—"),
      ]
    );
  },
});

@Component({
  components: { DetalleItem, FormularioPerfil, DialogoExito },
  computed: mapGetters({
    getUsuario: "usuario/get",
    getArrayCiudades: "ciudades/getArray",
    getRutasUsuario: "usuario/getRutas",
  }),
  methods: mapActions({
    setUsuario: "usuarios/set",
    setArchivo: "archivos/set",
    deleteArchivo: "archivos/delete",
  }),
})
export default class VistaPerfil extends Vue {
  dialogEditar = false;
  dialogoExito = {
    model: false,
    icono: "",
    texto: "",
  };

  get usuario(): Usuario | null {
    return this.getUsuario || null;
  }

  get arrayCiudades(): unknown[] {
    return this.getArrayCiudades || [];
  }

  /** Módulos a los que el usuario tiene permiso (rutas visibles en el menú) */
  get modulosConPermiso(): { show?: boolean; to?: { name?: string }; text?: string }[] {
    const rutas = this.getRutasUsuario || [];
    return rutas.filter((r: { show: boolean }) => r.show !== false);
  }

  get tipo(): string {
    return this.usuario?.tipo || "cliente";
  }

  get tipoFormateado(): string {
    const t = this.tipo;
    const map: Record<string, string> = {
      admin: "Administrador",
      cliente: "Cliente",
      relator: "Relator",
      supervisor: "Supervisor",
      operador: "Operador",
      administrador_locales: "Administrador Locales",
      gerente_general: "Gerente General",
      gerente_operaciones: "Gerente Operaciones",
      gerente_comercial: "Gerente Comercial",
    };
    return map[t] || t;
  }

  get ciudadNombre(): string {
    return this.usuario?.ciudad?.nombre ?? "Sin registrar";
  }

  get iniciales(): string {
    if (!this.usuario?.nombre) return "?";
    const parts = this.usuario.nombre.trim().split(/\s+/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return this.usuario.nombre.slice(0, 2).toUpperCase();
  }

  get avatarUrl(): string {
    const imgObj = this.usuario?.imagen;
    if (!imgObj) return "";
    const archivo = Object.values(imgObj)[0];
    return archivo?.url ?? (archivo?.file ? URL.createObjectURL(archivo.file) : "");
  }

  async clickGuardar(data: DataFormularioUsuario): Promise<void> {
    const doc = data.doc;
    const imagen = data.imagen;
    const borrar = data.borrar;

    for (const key in imagen) {
      if (imagen[key]?.file) {
        const res = await this.setArchivo(imagen[key]);
        if (res?.url) {
          this.$set(imagen, idtify(res.id), res);
        }
      }
    }
    for (const key in borrar) {
      if (borrar[key]) {
        await this.deleteArchivo(borrar[key].id);
      }
    }
    doc.imagen = imagen;
    await this.setUsuario(doc);

    this.dialogoExito = {
      model: true,
      texto: "Perfil actualizado correctamente",
      icono: require("@/assets/icons/double-check-duo.svg"),
    };
    this.cerrarDialogoEditar();
  }

  cerrarDialogoEditar(): void {
    this.dialogEditar = false;
  }

  cerrarDialogoExito(): void {
    this.dialogoExito = { model: false, icono: "", texto: "" };
  }
}
